import { gql } from '@/__generated__';
import { type GetPublicOrganizationQuery } from 'src/__generated__/graphql';

export type PublicDevice =
  GetPublicOrganizationQuery['publicOrganization']['devices']['nodes'][number];

const GET_PUBLIC_ORGANIZATION = gql(`#graphql
  query GetPublicOrganization($input: PublicOrganizationInput!, $pagination: PaginationInput) {
    publicOrganization(input: $input) {
      id
      name
      devices(pagination: $pagination) {
        nodes {
          name
          id
          telemetry {
            flow {
              data
              decimals
              unit
            }
            level {
              data
              decimals
              unit
            }
          }
        }
        pageInfo {
          count
          limit
          offset
          pageNumber
          totalCount
        }
      }
    }
  }
`);

export default GET_PUBLIC_ORGANIZATION;
